import { PlusKit } from 'education-icons';
import React from 'react';
import { useIntl } from 'react-intl';

import { SimpleCallback } from '../../typings';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import Text from '../text/text';

import './quiz-create-card.scss';

interface Props {
    onClick: SimpleCallback;
}

const { paragraphLMedium } = UI_KIT_TEXT_TYPOGRAPHY;

export const QuizCreateCard = (props: Props) => {
    const { onClick } = props;
    const intl = useIntl();

    const caption = intl.formatMessage({ id: 'quiz.create-quiz' });

    return (
        <article className="quiz-create-card" onClick={onClick}>
            <div className="quiz-create-card__caption">
                <PlusKit className="quiz-create-card__caption-icon" />
                <Text type={Text.TYPE.MARKDOWN} typography={paragraphLMedium}>
                    {caption}
                </Text>
            </div>
        </article>
    );
};
